import React from 'react'
import { currentOcupationStatusMessage } from './style'

const CurrentOcupationMessage = ({ currentOcupationStatus }) => {
  return (
    <div className="wrapper">
      <p className="title">
        <strong>Esta propiedad ya fue {currentOcupationStatus.label}.</strong>
      </p>
      <p className="subtitle">
        ¿Te interesa una similar? ¡Podemos ayudarte!
      </p>
      <style jsx>{currentOcupationStatusMessage}</style>
    </div>
  )
}

export default CurrentOcupationMessage
